require('./ui-grid');
module.exports = 'ui.grid';



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-grid/index.js
// module id = 344
// module chunks = 1